<template>


  <m-categories-wrapper :slicer="slicer">
    <b-row slot-scope="{ categories,imageHandler }">
      <b-col class="p-0 my-2" v-for="category in categories" :key="category.id" lg="3" sm="3">
        <div class="text-center">
          <m-c3>
            <template #p1>
              <m-img :alt="category.name" :src="imageHandler(category,alternativeCategoryImage)"
                     class="img-fluid card-image"/>
            </template>
            <template #p2>
              <m-h5 class="mt-3">
                <m-a class="text-dark " :href="{name:'Posts',query:{category:category.slug}}">{{
                    category.name
                  }}
                </m-a>
              </m-h5>
            </template>
            <template #p3>
              <m-p class="text-muted">
                {{ category.description }}
              </m-p>
            </template>
            <template #p4>
              <m-a :href="{name:'Posts',query:{category:category.slug}}">

                <b-button class="rounded-pill" variant="primary">
                  مشاهده
                  <b-icon icon="arrow-left"></b-icon>
                </b-button>
              </m-a>

            </template>
          </m-c3>
        </div>
      </b-col>
    </b-row>
  </m-categories-wrapper>


</template>

<script>
import {findAttributeOnSiteInfo} from "@moeinmdn/mixitweb-front-modules/src/plugin/class/FindAttributeOnSiteInfo";

export default {
  name: "Categories301",
  props: {
    alternativeCategoryImage: {
      default: () => {
        return findAttributeOnSiteInfo('icon')[0]
      },
    },
    slicer: {
      default: Infinity
    }
  },
  mounted() {
  }
}
</script>

<style scoped>
.card-image {
  height: 190px;
  object-fit: contain
}

.border-radius-none {
  border-radius: 0px !important;
}

</style>